import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import { Grid } from '@mui/material';
import { NotificationManager } from 'Components/Notifications';
import { Tabs, TabContainer, Modal, ModalBody, ModalFooter, Button, Input, Form, Checkbox } from "@gpstrackit/react-controls";
import EntityTagPicker from 'Modules/.common/.components/EntityTagPicker';

//actions
import {
    clearRedux,
    tagsOpenCreateEdit,
    tagsSaveTag,
    tagsGetTag,
    tagsGetEntities,
    generalCatalogInitial
} from 'Redux/actions';

const CreateEditTag = (props) => {
    const dispatch = useDispatch();
    const { callback } = props;
    const { messages } = useIntl();

    const editCreateAccountTag = useRef();

    const accounts = useSelector(state => state.createEditTagRedux.accounts);
    const units = useSelector(state => state.createEditTagRedux.units);
    const response = useSelector(state => state.createEditTagRedux.response);
    const loadingCreateEdit = useSelector(state => state.createEditTagRedux.loadingCreateEdit);
    const loadingTag = useSelector(state => state.createEditTagRedux.loadingTag);
    const id = useSelector(state => state.createEditTagRedux.id);
    const tag = useSelector(state => state.createEditTagRedux.tag);
    const open = useSelector(state => state.createEditTagRedux.openCreateEdit);
    const loadingEntities = useSelector(state => state.createEditTagRedux.loadingEntities);
    const disabledEntities = useSelector(state => state.createEditTagRedux.disabledEntities);

    const loadingEntityTagPicker = useSelector(state => state.entityTagPickerRedux.loading);

    const [formData, setFormData] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        return () => {
            dispatch(clearRedux("TAGS_CREATE_EDIT"));
            setFormData({});
        }
    }, []);

    useEffect(() => {
        if (!loadingCreateEdit && response != null) {
            dispatch(generalCatalogInitial());
        }
    }, [loadingCreateEdit]);

    useEffect(() => {
        if (id && open) {
            dispatch(tagsGetTag(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (units && open) {
            setFormData({ ...formData, unitIds: units.map(unit => { return unit.id }) });
        }
    }, [units, open]);

    useEffect(() => {
        if (accounts && open) {
            setFormData({ ...formData, companyIds: accounts.map(account => { return account.id }) });
        }
    }, [accounts, open]);

    useEffect(() => {
        if (tag && open) {
            if (tag.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                handleClose();
            } else {
                setFormData({ ...tag, tag: tag?.parent, nestUnder: tag.parentId ? true : false });
            }
        }
    }, [tag, open]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                /*
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                */

                dispatch(clearRedux("TAGS_CREATE_EDIT", { loadingCreateEdit: false, response: null }));
            } else {
                NotificationManager.success(
                    messages['tagsCreateEditTag_success'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                callback && callback();
                handleClose();
            }
        }
    }, [response, open]);

    const handleClose = useCallback(() => {
        dispatch(tagsOpenCreateEdit(false));
        dispatch(clearRedux("TAGS_CREATE_EDIT"));
        setFormData({});
    });

    const onSubmit = useCallback(() => {
        setErrorMessage(null);
        const trimmedLabel = (formData?.label || '').trim();
        if (!trimmedLabel) {
            NotificationManager.error(
                messages['required_field'],
                messages['pmtags_main_label'],
                3000
            );
            return;
        }

        let newFormData = {
            ...formData,
            label: trimmedLabel,
            color: formData?.color?.replace('#', '') || '8677D9',
            unitIds: formData?.unitIds || null,
            companyIds: formData?.companyIds || null,
        };

        if (newFormData.tag) {
            delete newFormData.tag;
        } else {
            newFormData.parentId = null;
        }

        if (formData.nestUnder && !newFormData.parentId) {
            setErrorMessage(messages['required_field']);
            return;
        }

        dispatch(tagsSaveTag(newFormData));
    });

    const title = tag ? `${messages['tagsCreateEditTag_editTitle']} '${tag?.label}'` : `${messages['tagsCreateEditTag_createTitle']}`;

    return (
        <Modal
            title={title}
            open={open}
            loading={loadingTag}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            //className="overflow-hidden"
            handleClose={handleClose}
        >
            <ModalBody
                style={{
                    overflow: 'hidden',
                    marginBottom: 0
                }}
            >
                <div
                    style={{
                        padding: "0px 24px 24px 24px",
                        height: "calc(100vh - 225px)"
                    }}
                >
                    <Tabs
                        onChange={(newTab) => {
                            if (newTab > 0 && id) {
                                let entityName;
                                if (newTab === 1 && !units.length) {
                                    entityName = "Company";
                                } else if (newTab === 2 && !accounts.length) {
                                    entityName = "Unit";
                                }

                                if (entityName) {
                                    dispatch(tagsGetEntities({
                                        parentTagId: id,
                                        entityName: entityName,
                                    }));
                                }
                            }
                        }}
                    >
                        <TabContainer
                            label={messages['tagsCreateEditTag_tag']}
                            index={0}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            disabled={loadingEntityTagPicker}
                        >
                            <Form ref={editCreateAccountTag} onValidSubmit={onSubmit}>
                                <div style={{ width: '100%' }}>
                                    <label className='input-normal-label'>
                                        {messages['tagsCreateEditTag_color']} <span className="text-danger"> *</span>
                                    </label>
                                </div>

                                <Grid
                                    container
                                    wrap="nowrap"
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                    style={{ width: '100%' }}
                                >
                                    <div style={{ textAlign: '', display: 'flex', padding: '10px 0px', marginTop: 5 }}>
                                        <div style={{ textAlign: 'left', padding: '8px 0px' }}>
                                            <input type="color" id="head" name="head" value={`#${formData.color}`} onChange={(e) => {
                                                setFormData({ ...formData, color: e.target.value.replace('#', '') })
                                            }} />
                                        </div>
                                        <div style={{ textAlign: 'left', marginLeft: '10px', width: '90%' }}>
                                            <Input
                                                value={formData.label || ""}
                                                onChange={(value) => setFormData({ ...formData, label: value })}
                                                maxLength={50}
                                                required
                                                requiredMessage={messages['required_field']}
                                            />

                                        </div>
                                    </div>
                                </Grid>
                            </Form>
                        </TabContainer>

                        <TabContainer
                            label={messages['tagsCreateEditTag_account']}
                            index={1}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            disabled={loadingEntityTagPicker || loadingEntities || disabledEntities}
                        >
                            <EntityTagPicker
                                entity="Company"
                                height="calc(100vh - 320px)"
                                value={formData?.companyIds || []}
                                onChange={(newCompanyIds) => {
                                    setFormData({ ...formData, companyIds: newCompanyIds });
                                }}
                            />
                        </TabContainer>
                        <TabContainer
                            label={messages['tagsCreateEditTag_unit']}
                            index={2}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            disabled={loadingEntityTagPicker || loadingEntities || disabledEntities}
                        >
                            <EntityTagPicker
                                entity="Unit"
                                height="calc(100vh - 320px)"
                                value={formData?.unitIds || []}
                                onChange={(newUnitIds) => {
                                    setFormData({ ...formData, unitIds: newUnitIds });
                                }}
                            />
                        </TabContainer>
                    </Tabs>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loadingCreateEdit}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingCreateEdit}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editCreateAccountTag.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default CreateEditTag;